import { __assign, __rest } from "tslib";
import React from 'react';
import { useBiClickLogger } from '../hooks/useBiClickLogger';
var BiSpan = function (_a) {
    var biData = _a.biData, innerRef = _a.innerRef, stopPropagation = _a.stopPropagation, props = __rest(_a, ["biData", "innerRef", "stopPropagation"]);
    var setTrackingRef = useBiClickLogger(biData, stopPropagation).setTrackingRef;
    return (React.createElement("span", __assign({}, props, { ref: function (node) {
            setTrackingRef(node);
            innerRef && innerRef(node);
        } })));
};
BiSpan.displayName = 'BiSpan';
export default BiSpan;
//# sourceMappingURL=BiSpan.js.map